import React from 'react';
import { Award, Users, Flag, Clock } from 'lucide-react';

const badges = [
  { icon: Users, title: 'Professionnels & Particuliers', description: 'Tous types de chantiers' },
  { icon: Flag, title: '100% Français', description: 'Réalisations françaises' },
  { icon: Award, title: 'Certifié RGE', description: 'Aides financières éligibles' },
  { icon: Clock, title: '11 ans d\'expérience', description: 'Savoir-faire depuis 2015' }
];

const TrustBadges = () => {
  return (
    <section className="bg-[#01162D] border-t border-[#1F6FD6]/40" data-testid="trust-badges">
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 md:gap-y-0 md:divide-x divide-[#1F6FD6]/25">
          {badges.map((badge, index) => {
            const IconComponent = badge.icon;
            return (
              <div key={index} className="flex flex-col items-center text-center px-4 py-3 group" data-testid={`trust-badge-${index + 1}`}>
                <div className="w-14 h-14 md:w-16 md:h-16 border-2 border-[#3B8BEF] rounded-md flex items-center justify-center mb-4 group-hover:bg-[#1F6FD6] transition-colors duration-300">
                  <IconComponent size={30} className="text-[#3B8BEF] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xs md:text-base font-bold text-white uppercase tracking-wider mb-1">
                  {badge.title}
                </h3>
                <p className="text-xs md:text-sm text-[#9FB3CC]">{badge.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
